import { Model } from '@/models/Model';
export class GroupGoalPlannerTemplate extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'GroupGoalPlannerTemplate';
        this.$endpoint = '/group-templates';
        this.$fillable = ['title', 'day', 'starts_at', 'ends_at'];
    }
}
